module.exports = __webpack_public_path__ + "static/media/gravelWalk.5291d1c2.mp3";